module.exports = "assets/images/regions.png";